import { render, staticRenderFns } from "./wayverPage.vue?vue&type=template&id=3063f1b2&"
import script from "./wayverPage.vue?vue&type=script&lang=ts&"
export * from "./wayverPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports